const formatDate = date => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

const dbDateToPtBR = date => {
  const split = date.split(' ')[0].split('-');

  var d = new Date([split[1], split[2], split[0]].join('/'));
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month].join('/');
};

const parseDateBR = date => {
  const split = date.split(' ')[0].split('-');

  var d = new Date([split[1], split[2], split[0]].join('/'));
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, d.getFullYear()].join('/');
};

const parseDate = date => {
  const split = date.split(' ')[0].split('-');

  var d = new Date([split[1], split[2], split[0]].join('/'));
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [month, day, d.getFullYear()].join('/');
};

const curday = sp => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  return yyyy + sp + mm + sp + dd + ' 00:00:00';
};

export { formatDate, dbDateToPtBR, parseDateBR, parseDate, curday };
